import React from 'react';
import { motion } from 'framer-motion';

const partners = [
  {
    name: 'AWS',
    logo: '/AWS-logo.svg',
    description: 'Amazon Web Services Partner',
    className: 'h-16 md:h-20 brightness-0 invert'
  },
  {
    name: 'Cisco',
    logo: '/Cisco-logo.svg',
    description: 'Cisco Systems Partner',
    className: 'h-16 md:h-20 brightness-0 invert'
  },
  {
    name: 'Vaimo',
    logo: '/Vaimo-Logo.svg',
    description: 'Vaimo Technology Partner',
    className: 'h-8 md:h-10 brightness-0 invert'
  },
  {
    name: 'Merixstudio',
    logo: '/Merixstudio-Logo.svg',
    description: 'Merixstudio',
    className: 'h-10 md:h-12'
  },
  {
    name: 'Exalogic',
    logo: '/Exalogic-logo.webp',
    description: 'Exalogic Consulting Partner',
    className: 'h-8 md:h-10'
  }
];

const Partnerships = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-display font-semibold text-white mb-6">
            Our Strategic Partners
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Collaborating with industry leaders to deliver exceptional solutions
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-8 items-center">
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="flex flex-col items-center group"
            >
              <div className="w-full h-24 flex items-center justify-center">
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className={`object-contain opacity-60 group-hover:opacity-100 transition-opacity duration-300 ${partner.className}`}
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partnerships;